<template>
  <div
    class="px-4 py-4 bg-white border-b border-gray-200 shadow-sm md:shadow-none sm:flex"
    role="search"
    aria-label="Student filters"
    aria-description="Filter students by major, session or city"
  >
    <div class="sm:flex-auto sm:flex">
      <label
        class="block text-sm mb-2 sm:mb-0 sm:flex-1 sm:mr-5"
        v-if="showCity"
        for="cities"
      >
        <v-select
          id="cities"
          class="filters"
          placeholder="City"
          v-model="filters.city"
          :value="filters.city"
          :options="cities"
          :reduce="city => city.value"
          aria-label="Cities"
        />
      </label>
      <multiselect
        :id="'sessions'"
        :placeholder="'Session'"
        :data="sessions"
        :clear="clear.sessions"
        v-model="filters.sessions"
        @input="
          newSessions => {
            filters.sessions = newSessions.slice();
          }
        "
        @changeClear="
          () => {
            clear.sessions = false;
          }
        "
      />

      <multiselect
        :id="'majors'"
        :placeholder="'Major'"
        :data="majors"
        :clear="clear.majors"
        v-model="filters.majors"
        @input="
          newMajors => {
            filters.majors = newMajors.slice();
          }
        "
        @changeClear="
          () => {
            clear.majors = false;
          }
        "
      />

      <label
        class="block text-sm mb-2 sm:mb-0 sm:flex-1 sm:mr-5"
        v-if="showApproval"
        for="approval"
      >
        <v-select
          :id="'approval'"
          class="filters"
          placeholder="Approval status"
          v-model="filters.approvalStatus"
          :value="filters.approvalStatus"
          :options="approvalStatus"
          :reduce="status => status.value"
          aria-label="Approval status"
        />
      </label>
    </div>
    <div class="flex items-center flex-none">
      <button
        class="inline-block text-center rounded font-semibold border-2 border-transparent px-4 min-h-10 bg-white border-teal-500 text-teal-500 flex-auto hover:bg-teal-100 hover:text-white hover:border-teal-100"
        @click="filter()"
      >
        <span>Filter</span>
      </button>
      <button
        class="flex items-center justify-center px-4 ml-2 text-sm min-h-10 text-gray-650 focus:outline-none"
        type="reset"
        @click="resetFilters()"
      >
        Reset
      </button>
    </div>
  </div>
</template>

<script>
import json from "../tabs/major.json";
import { mapGetters } from "vuex";
import multiselect from "./Multiselect.vue";
import { APPROVAL_STATUS } from "../../../constants";

export default {
  name: "filters",
  components: {
    multiselect: multiselect
  },
  props: {
    showApproval: {
      type: Boolean,
      default: false
    },
    showCity: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cities: [],
      sessions: [],
      majors: json,
      approvalStatus: APPROVAL_STATUS,
      filters: {
        city: "",
        sessions: [],
        majors: [],
        approvalStatus: ""
      },
      clear: {
        sessions: false,
        majors: false
      }
    };
  },
  computed: {
    ...mapGetters(["getLastFilters"])
  },
  created() {
    this.filters = Object.assign({}, this.getLastFilters);
    this.getCities();
    this.getSession();
  },
  methods: {
    async getCities() {
      fetch(process.env.VUE_APP_ENROLLMENT_URL + "/api/locations", {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          "x-jwt-token": this.$store.state.advisor.token
        }
      })
        .then(response => response.json())
        .then(json => {
          if (json.length) {
            let cities = json.map(item => ({
              label: item,
              value: item
            }));
            this.cities = cities;
          }
        })
        .catch(error => {
          console.log("Error something went wrong: " + error);
        });
    },
    async getSession() {
      fetch(process.env.VUE_APP_ENROLLMENT_URL + "/api/sessions", {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          "x-jwt-token": this.$store.state.advisor.token
        }
      })
        .then(response => response.json())
        .then(json => {
          if (json.length) {
            let sessions = json.map(item => ({
              label: item,
              value: item
            }));
            this.sessions = sessions;
          }
        })
        .catch(error => {
          console.log("Error something went wrong: " + error);
        });
    },
    filter() {
      this.$emit("getFilterData", this.filters);
    },
    resetFilters() {
      this.clear.sessions = true;
      this.clear.majors = true;

      this.filters.city = null;
      this.filters.sessions = [];
      this.filters.majors = [];
      this.filters.approvalStatus = "";
      this.$emit("getFilterData", this.filters);
    }
  }
};
</script>
